import type { NuxtApp } from '#app'
import { useAccountStore } from '~/stores/account'
import { createSDK } from '@/api'
import { useApiClient } from '~/services/api'

export default defineNuxtPlugin(async nuxtApp => {
  type __NuxtApp = typeof nuxtApp &
    Pick<NuxtApp, '$i18n' | '$normalizePath' | '$snacks'>

  const { hooks, $i18n, $normalizePath } = nuxtApp as __NuxtApp
  const appConfig = useAppConfig()
  const runtimeConfig = useRuntimeConfig()

  const accountStore = useAccountStore()

  const sdk = await createSDK({
    projectId: parseInt(runtimeConfig.public.appProjectId, 10),
    api: {
      language: $i18n.locale.value,
      onResponseError: (error, id) => {
        hooks.callHook('api-client:error' as any, error, id)
      }
    }
  })

  sdk.setModuleOptions('auth', {
    callbackPath: appConfig.auth.callbackPath,
    navigateTo,
    normalizePath: $normalizePath,
    onPopupAuthError: (errorMessage: string) => {
      const { $snacks } = nuxtApp as __NuxtApp
      $snacks?.error?.(errorMessage)
    },
    onFetchAccount: (account: any) => {
      if (account) {
        accountStore.account = account
      }
    },
    accountRequestQuery: {
      expand: ['coins', 'profile', 'styles', 'scopes', 'lsPromo'],
      fields: [
        'id',
        'email',
        'uid',
        'username',
        'avatar',
        'coins',
        'profile.agree',
        'steam_id',
        'created_at'
      ]
    }
  })

  sdk.setModuleOptions('common', {
    hostWS: runtimeConfig.public.wsBaseHost
  })

  const api = await useApiClient()

  return {
    provide: {
      sdk,
      api
    }
  }
})
